import { render, staticRenderFns } from "./buyShopMultipleSelect.vue?vue&type=template&id=70bcf284"
import script from "./buyShopMultipleSelect.vue?vue&type=script&lang=js"
export * from "./buyShopMultipleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports